module.exports = fox._r("fonts/mc-admin-common.svg", __webpack_public_path__ + "_/_/_/common/frame/fonts/mc-admin-common.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/fonts/mc-admin-common.svg
// module id = 116
// module chunks = 2